const DEPLOYMENT_STAGES = ['LOCAL', 'DEV', 'STAGE', 'PROD'] as const;
const deploymentStage = import.meta.env.VITE_DEPLOYMENT_STAGE?.toUpperCase();

export const DEPLOYMENT_STAGE =
  deploymentStage &&
  DEPLOYMENT_STAGES.includes(deploymentStage as (typeof DEPLOYMENT_STAGES)[number])
    ? deploymentStage
    : 'LOCAL';

export const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN;
export const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID;
export const AUTH0_AUDIENCE = import.meta.env.VITE_AUTH0_AUDIENCE;
export const ONESCHEMA_CLIENT_ID = import.meta.env.VITE_ONESCHEMA_CLIENT_ID;
export const DATADOG_APP_ID = import.meta.env.VITE_DATADOG_APP_ID;
export const DATADOG_CLIENT_TOKEN = import.meta.env.VITE_DATADOG_CLIENT_TOKEN;
export const COMMIT_SHA1 = import.meta.env.VITE_COMMIT_SHA1;

// Easier to mock in tests
// TODO, replace usage of DEPLOYMENT_STAGE with getEnv() in all components
export const getEnv = () => DEPLOYMENT_STAGE;
